import { BaseEnumEx } from './base-enum-ex'

// NOTE: Make sure this stays in sync with the server-side enum
export enum MaterialTicketType {
    SandGravel,
    HaulOff,
    Concrete,
}

export class MaterialTicketTypeEx extends BaseEnumEx {
    public static toDisplay(item: MaterialTicketType) {
        switch (item) {
            case MaterialTicketType.SandGravel:
                return 'Sand/Gravel'
            case MaterialTicketType.HaulOff:
                return 'Haul Off'
            case MaterialTicketType.Concrete:
                return 'Concrete'
        }
        return 'Unknown'
    }
}
